<template>
    <path d="M16.465 14.648c0-.199-.082-.386-.223-.527L14.122 12l2.12-2.121c.14-.14.223-.328.223-.527 0-.2-.082-.399-.223-.54l-1.055-1.054c-.14-.14-.34-.223-.539-.223s-.386.082-.527.223L12 9.878l-2.121-2.12c-.14-.14-.328-.223-.527-.223-.2 0-.399.082-.54.223L7.758 8.812c-.14.141-.223.34-.223.54 0 .199.082.386.223.527L9.878 12l-2.12 2.121c-.14.14-.223.328-.223.527 0 .2.082.399.223.54l1.054 1.054c.141.14.34.223.54.223.199 0 .386-.082.527-.223L12 14.122l2.121 2.12c.14.14.328.223.527.223.2 0 .399-.082.54-.223l1.054-1.055c.14-.14.223-.34.223-.539zM21 12c0 4.969-4.031 9-9 9s-9-4.031-9-9 4.031-9 9-9 9 4.031 9 9z" transform="translate(-816 -473) translate(813 470)"/>
</template>

<script>
export default {
    name: 'closeCircleIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 18');
    }
};
</script>
